import { Form } from 'formik';
import { hostFormNames, type THostFormValues } from '@shared/forms/host';
import { Textfield } from '@shared/fields/text-field';
import { TextAreafield } from '@shared/fields/text-area-field';
import { Label } from '@src/design-system/label';
import {
  Upload,
  UploadArea,
  UploadButton,
  UploadError,
  UploadInputDisplay,
  UploadTrigger,
} from '@src/design-system/upload';
import { FormikCountryField } from '@shared/fields/country-field/formik-country-field';
import { PhoneNumberInput } from '@src/design-system/phone-number-input';

const {
  companyName,
  address1,
  address2,
  city,
  companyDescription,
  companyLogo,
  country,
  postalCode,
  state,
  contactName,
  contactJobTitle,
  contactEmail,
  contactPhoneNumber,
  website,
} = hostFormNames;

export function CreateHostForm({
  values,
  setFieldValue,
  isTableView,
}: {
  values: THostFormValues;
  setFieldValue: (field: string, value: unknown) => void;
  isTableView?: boolean;
}) {
  return (
    <Form className='flex flex-col h-full'>
      <div className='space-y-6'>
        <div>
          <Textfield
            name={companyName}
            label='Company name'
            placeholder='e.g. Orange'
          />
        </div>

        {isTableView && (
          <div className='space-y-6'>
            <Textfield
              name={contactName}
              label='Contact Name (Optional)'
              placeholder='e.g. John Doe'
            />
            <Textfield
              name={contactJobTitle}
              label='Job Title (Optional)'
              placeholder='e.g. Director'
            />
            <Textfield
              name={contactEmail}
              label='Email (Optional)'
              placeholder='e.g. john.doe@example.com'
            />
            <div className='flex flex-col gap-1'>
              <Label className='mb-1'>Phone Number (Optional)</Label>
              <PhoneNumberInput
                name={contactPhoneNumber}
                placeholder='ex: +20124356762'
                onChange={(value) => setFieldValue(contactPhoneNumber, value)}
                value={values[contactPhoneNumber]}
              />
            </div>
            <Textfield
              name={website}
              label='Website (Optional)'
              placeholder='e.g. https://www.example.com'
            />
          </div>
        )}

        <Textfield
          name={address1}
          label='Address 1'
          placeholder='e.g. 123 Main Street, Apartment 4B'
        />

        <Textfield
          name={address2}
          label='Address 2 (optional)'
          placeholder='e.g. Floor, Landmark, Building Name'
        />

        <Textfield
          name={city}
          label='City'
          placeholder='e.g. Cairo'
        />

        <Textfield
          name={state}
          label='State/ Province (optional)'
          placeholder='e.g. Maadi'
        />

        <div>
          <Label>Country</Label>
          <FormikCountryField
            isInModal
            selectName={country}
          />
        </div>

        <Textfield
          name={postalCode}
          label='Zip/ Postal Code (optional)'
          placeholder='e.g. 123456'
        />

        <Upload onFileChange={(file) => setFieldValue(companyLogo, file)}>
          <Label>Company logo (Optional)</Label>
          <UploadArea>
            <UploadTrigger>
              <UploadButton />
              <UploadInputDisplay
                onFileRemove={() => setFieldValue(companyLogo, '')}
              />
            </UploadTrigger>
          </UploadArea>
          <UploadError />
        </Upload>

        <div>
          <TextAreafield
            name={companyDescription}
            label='Company description'
          />
        </div>
      </div>
    </Form>
  );
}
